import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { filterArray } from '../common/Helpers';
import ContactDetailsFilter from './ContactDetailsFilter';
import { matchesContactFilter, normalizeContactFilter } from './contactFilterRules';
import { history } from "../../redux/store/configureStore";
import TeachersList from "./TeachersList";
import * as teacherActions from "../../redux/actions/teacherActions";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";

const isActiveTeacher = teacher => teacher.archived !== true && teacher.deleted !== true;
const isArchivedTeacher = teacher => teacher.archived === true && teacher.deleted !== true;

export function Teachers({
  teachers,
  loadTeachers,
  peopleViewState,
  onPeopleViewStateChange,
}) {
  const [contactFilter, setContactFilter] = useState(normalizeContactFilter(peopleViewState && peopleViewState.contactFilter));
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const [search, setSearch] = useState(peopleViewState.search || "");
  const [showArchivedTeachers, setShowArchivedTeachers] = useState(Boolean(peopleViewState.showArchived));

  useEffect(() => {
    if (teachers.length === 0) {
      loadTeachers()
        .catch((error) => {
          alert(`Loading teachers failed ${error}`);
        });
    }
  }, []);


  const handleEdit = (teacher) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/teacher/${teacher.id}`, location.search, activeSchoolYearStartYear));
  };

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/teacher/new", location.search, activeSchoolYearStartYear));
  };

  const handleShowArchivedTeachers = () => {
    const nextValue = !showArchivedTeachers;
    setShowArchivedTeachers(nextValue);
    onPeopleViewStateChange({ showArchived: nextValue });
  };

  const archivedTeachers = showArchivedTeachers
    ? teachers.filter(isArchivedTeacher)
    : teachers.filter(isActiveTeacher);

  const filteredTeachers = filterArray(search, archivedTeachers).filter(person => matchesContactFilter(person, contactFilter));

  const handleContactFilter = value => {
    setContactFilter(value);
    onPeopleViewStateChange({ contactFilter: value });
  };
  const clearFilters = () => {
    setSearch('');
    setContactFilter('all');
    setShowArchivedTeachers(false);
    onPeopleViewStateChange({ search: '', contactFilter: 'all', showArchived: false });
  };

  return (
    <div className="mb-5">
      <h2 className="manage-title mb-3 pb-0">Nauczyciele</h2>
      <div className="contact-toolbar">
      <input aria-label="Szukaj nauczyciela" placeholder="szukaj" className="form-control contact-search" value={search} onChange={event => {
        setSearch(event.target.value);
        onPeopleViewStateChange({ search: event.target.value });
      }} />
      <ContactDetailsFilter value={contactFilter} onChange={handleContactFilter} onClear={clearFilters} empty={filteredTeachers.length === 0} />
        <label className="contact-archive"><input type="checkbox" checked={showArchivedTeachers} onChange={handleShowArchivedTeachers} />Archiwum</label>
        {!showArchivedTeachers && <button type="button" className="btn manage-button btn-success contact-add" onClick={handleAdd}>Dodaj nowego nauczyciela</button>}
      </div>
      <TeachersList hideControls
        teachers={filteredTeachers}
        onAdd={handleAdd}
        onEdit={handleEdit}
        showArchivedTeachers={showArchivedTeachers}
        onShowArchivedTeachers={handleShowArchivedTeachers}
        initialNumToShow={peopleViewState.numToShow}
        onNumToShowChange={numToShow => onPeopleViewStateChange({ numToShow })}
      />
    </div>
  );
}

Teachers.propTypes = {
  teachers: PropTypes.array.isRequired,
  loadTeachers: PropTypes.func.isRequired,
  peopleViewState: PropTypes.shape({
    showArchived: PropTypes.bool,
    numToShow: PropTypes.number,
    contactFilter: PropTypes.string,
    search: PropTypes.string,
  }),
  onPeopleViewStateChange: PropTypes.func,
};

Teachers.defaultProps = {
  peopleViewState: { showArchived: false, numToShow: 25 },
  onPeopleViewStateChange: () => {},
};

const mapStateToProps = state => ({
  teachers: state.teachers,
});

const mapDispatchToProps = dispatch => ({
  loadTeachers: () => dispatch(teacherActions.loadTeachers()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Teachers);
